import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ERoutes } from '../../../assets/constants/routes';

export function InviteUserToRegisterComponent(props: any) {
  const navigateHome = () => {
    if (props.wishlistId) {
      const url = `${process.env.REACT_APP_BASE_URL}${ERoutes.CONTACT_WISH_LIST.replace(':wishListId', props.wishlistId)}`;
      window.open(url);
    } else {
      window.open(`${process.env.REACT_APP_BASE_URL}`);
    }
  };

  return (
    <div className='d-flex flex-column flex-sm-row p-2' style={{ backgroundColor: '#ebad29' }}>
      <div className='col-12 col-sm-9'>
        <div className='text-center text-sm-left'>
          <span><b><FormattedMessage id='pages.wishlist.public.invite.title' /></b></span>
          <FormattedMessage id='pages.wishlist.public.invite.description' />
        </div>
      </div>
      <div className='col-12 p-2 col-sm-3 text-center'>
        <button className='btn-lili secondary' onClick={navigateHome}>
          <FormattedMessage id='common.signup' />
        </button>
      </div>
    </div>
  );
}
